import { CARRIER_NAMES } from './constants';

export type BenefitPaymentMode = 'reimbursement' | 'indemnity';

export type BenefitPaymentCapabilities = {
  default: BenefitPaymentMode;
  supports: BenefitPaymentMode[];
};

type CapabilityQuote = {
  carrierName?: string | null;
};

const CAPABILITIES_BY_CARRIER: Record<string, BenefitPaymentCapabilities> = {
  [CARRIER_NAMES.ONE_AMERICA]: {
    default: 'reimbursement',
    supports: ['reimbursement'],
  },
  [CARRIER_NAMES.LINCOLN_FINANCIAL]: {
    default: 'reimbursement',
    supports: ['reimbursement', 'indemnity'],
  },
};

const DEFAULT_CAPABILITIES: BenefitPaymentCapabilities = {
  default: 'indemnity',
  supports: ['indemnity'],
};

export function getBenefitPaymentCapabilities(quote: CapabilityQuote): BenefitPaymentCapabilities {
  if (!quote.carrierName) return DEFAULT_CAPABILITIES;
  return CAPABILITIES_BY_CARRIER[quote.carrierName] ?? DEFAULT_CAPABILITIES;
}

export function quoteSupportsBenefitPaymentMode(
  quote: CapabilityQuote,
  mode: BenefitPaymentMode,
): boolean {
  return getBenefitPaymentCapabilities(quote).supports.includes(mode);
}
